import React, { useState } from "react";
import { Modal, Button, Table } from "antd";
import type { ColumnsType } from "antd/es/table";

interface DataType {
  benId: number;
  name: string;
}

type IndexLetterModalProps = {
    isModalOpen: boolean;
    handleSave: any;
    handleCancel: () => void;
    indexCardPatients: DataType[];
}

const IndexLetterModal: React.FC<IndexLetterModalProps> = ({
    isModalOpen,
    handleSave,
    handleCancel,
    indexCardPatients
}) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const columns: ColumnsType<DataType> = [
    {
      title: "Select",
      dataIndex: "select",
      render: (_: any, record: DataType) => (
        <input
          type="checkbox"
          checked={selectedId === record.benId}
          onChange={() => handleCheckboxChange(record.benId)}
        />
      ),
    },
    {
      title: "Beneficiary ID",
      dataIndex: "benId",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
  ];

  const handleCheckboxChange = (id: number) => {
    setSelectedId((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <Modal
        title="Select Patient"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={() => {
            handleSave(selectedId);
            setSelectedId(null); // Reset selection after saving
          }} disabled={selectedId === null}>
            Save
          </Button>,
        ]}
      >
        <Table
          dataSource={indexCardPatients}
          columns={columns}                      
          rowKey="id"
          pagination={false}
        />
      </Modal>
    </>
  );
};

export default IndexLetterModal;
